import { TemaCard } from 'src/data/models/TemaCardModel';

export const housingCards: TemaCard[] = [
    // 🏘 Searching for a place
    new TemaCard(
        'house1',
        'Housing',
        'sentence',
        'Estoy buscando un piso para alquilar.',
        'I’m looking for an apartment to rent.',
        'Start with this when speaking to agents or landlords.'
    ),

    new TemaCard(
        'house2',
        'Housing',
        'phrase',
        '¿Está disponible este piso todavía?',
        'Is this apartment still available?',
        'Useful when responding to online listings.'
    ),

    new TemaCard(
        'house3',
        'Housing',
        'phrase',
        '¿Está amueblado?',
        'Is it furnished?',
        'Important for long- or short-term rentals.'
    ),

    new TemaCard(
        'house4',
        'Housing',
        'sentence',
        '¿Está cerca del transporte público?',
        'Is it near public transport?',
        'Ask this when evaluating location and accessibility.'
    ),

    new TemaCard(
        'house5',
        'Housing',
        'sentence',
        '¿Puedo programar una visita?',
        'Can I schedule a visit?',
        'Essential phrase to arrange a viewing.'
    ),

    // 📝 Rental conditions & contracts
    new TemaCard(
        'house6',
        'Housing',
        'word',
        'contrato',
        'contract',
        'Legal and financial terms in rental agreements.',
        [
            { spanish: 'depósito', english: 'deposit' },
            { spanish: 'alquiler', english: 'rent' },
            { spanish: 'fianza', english: 'security deposit' },
            { spanish: 'facturas', english: 'bills' },
            { spanish: 'duración', english: 'duration' },
        ]
    ),

    new TemaCard(
        'house7',
        'Housing',
        'sentence',
        '¿Qué incluye el contrato?',
        'What is included in the contract?',
        'Ask this before signing anything.'
    ),

    new TemaCard(
        'house8',
        'Housing',
        'sentence',
        '¿Cuánto tengo que pagar de fianza?',
        'How much is the deposit?',
        'Deposits are often 1–2 months of rent.'
    ),

    new TemaCard(
        'house9',
        'Housing',
        'sentence',
        '¿A nombre de quién está el contrato?',
        'Whose name is on the contract?',
        'Ask to confirm legal responsibility.'
    ),

    // 🧱 Apartment Features
    new TemaCard(
        'house10',
        'Housing',
        'word',
        'habitaciones',
        'rooms',
        'Descriptions of the apartment’s layout.',
        [
            { spanish: 'salón', english: 'living room' },
            { spanish: 'cocina', english: 'kitchen' },
            { spanish: 'baño', english: 'bathroom' },
            { spanish: 'balcón', english: 'balcony' },
            { spanish: 'terraza', english: 'terrace' },
        ]
    ),

    new TemaCard(
        'house11',
        'Housing',
        'sentence',
        'Tiene dos habitaciones y mucha luz natural.',
        'It has two rooms and lots of natural light.',
        'Use this to describe or confirm apartment details.'
    ),

    new TemaCard(
        'house12',
        'Housing',
        'phrase',
        '¿Hay calefacción o aire acondicionado?',
        'Is there heating or air conditioning?',
        'Ask about essential utilities.'
    ),

    new TemaCard(
        'house13',
        'Housing',
        'phrase',
        '¿Se permite tener mascotas?',
        'Are pets allowed?',
        'Important for animal lovers.'
    ),

    // ⚠️ Problems, maintenance & rights
    new TemaCard(
        'house14',
        'Housing',
        'sentence',
        'Hay una fuga de agua en el baño.',
        'There’s a water leak in the bathroom.',
        'Report issues to landlord or admin.'
    ),

    new TemaCard(
        'house15',
        'Housing',
        'phrase',
        'La lavadora no funciona.',
        'The washing machine doesn’t work.',
        'Very common maintenance problem.'
    ),

    new TemaCard(
        'house16',
        'Housing',
        'phrase',
        'Necesito un electricista/plomero.',
        'I need an electrician/plumber.',
        'For urgent fixes.'
    ),

    new TemaCard(
        'house17',
        'Housing',
        'phrase',
        '¿Quién paga por las reparaciones?',
        'Who pays for the repairs?',
        'Clarify who is responsible.'
    ),

    new TemaCard(
        'house18',
        'Housing',
        'phrase',
        '¿Me puede dar un recibo del pago?',
        'Can you give me a payment receipt?',
        'Important to avoid scams.'
    ),

    // 🚚 Moving in/out & utilities
    new TemaCard(
        'house19',
        'Housing',
        'phrase',
        '¿Cuándo puedo mudarme?',
        'When can I move in?',
        'Ask this after agreeing to rent.'
    ),

    new TemaCard(
        'house20',
        'Housing',
        'sentence',
        '¿Las facturas están incluidas en el precio?',
        'Are utilities included in the price?',
        'Clarifies what you’re really paying.'
    ),

    new TemaCard(
        'house21',
        'Housing',
        'word',
        'facturas',
        'bills',
        'Useful vocabulary around household costs.',
        [
            { spanish: 'agua', english: 'water' },
            { spanish: 'luz', english: 'electricity' },
            { spanish: 'gas', english: 'gas' },
            { spanish: 'internet', english: 'internet' },
        ]
    ),

    new TemaCard(
        'house22',
        'Housing',
        'phrase',
        'Gracias, lo pensaré.',
        'Thanks, I’ll think about it.',
        'Polite way to decline or delay a decision.'
    ),

    new TemaCard(
        'house23',
        'Housing',
        'phrase',
        '¿Hay algún coste adicional?',
        'Are there any additional costs?',
        'Ask to avoid hidden fees.'
    ),
];
